var _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _g3, _path8, _rect2, _rect3, _rect4, _g4, _rect5, _rect6, _path9, _circle, _rect7, _path0, _path1, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallDiagramCallouts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 620",
    width: 1000,
    height: 620,
    fill: "none",
    stroke: "#191a1c",
    strokeWidth: 2.6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 724,
    y: 52,
    width: 276,
    height: 488,
    fill: "#f5f5f2",
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M724,52 V540",
    stroke: "#c9c9c3",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M740,120 H1000 M740,220 H1000 M740,320 H1000 M740,420 H1000",
    stroke: "#dededa",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,540 H1000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,556 L36,540 M60,556 L76,540 M100,556 L116,540 M140,556 L156,540 M660,556 L676,540 M700,556 L716,540 M740,556 L756,540 M780,556 L796,540 M820,556 L836,540 M860,556 L876,540 M900,556 L916,540 M940,556 L956,540",
    stroke: "#b9b9b3",
    strokeWidth: 1.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#dcdcd6",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,192 V526 M206,192 V526 M232,192 V526 M258,192 V526 M284,192 V526 M310,192 V526 M336,192 V526 M362,192 V526 M388,192 V526 M414,192 V526 M440,192 V526 M466,192 V526 M492,192 V526 M518,192 V526"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156,272 q23,-11 46,0 t46,0 t46,0 t46,0 t46,0 t46,0 t46,0 t46,0 L524,526 H156 Z",
    fill: "#d8e6fb",
    fillOpacity: 0.9,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156,272 q23,-11 46,0 t46,0 t46,0 t46,0 t46,0 t46,0 t46,0 t46,0",
    stroke: "#7fa4e0",
    strokeWidth: 2.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140,190 V540 M156,190 V526 M524,190 V526 M540,190 V540 M156,526 H524 M140,540 H540"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(348,304) scale(0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,92 V74 C50,62 62,56 62,46 H78 C78,56 90,62 90,74 V92",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,92 V262 M90,92 V262",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,142 H90 M50,186 H90",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,262 V276 C50,282 54,286 60,286 H80 C86,286 90,282 90,276 V262",
    strokeWidth: 3.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,262 H90",
    strokeWidth: 3.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,162) scale(0.42)",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,30 H196 V205 H180 V67 H126 V180 H110 V67 H24 Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 48,
    r: 12,
    strokeWidth: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 48,
    r: 12,
    strokeWidth: 4.5
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400,338 V206 C400,184 412,168 436,168 H542 C550,168 553,175 553,190 V518 C553,530 559,534 571,534 H768 C780,534 784,528 784,516 V414",
    strokeWidth: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 489,
    y: 159,
    width: 21,
    height: 38,
    rx: 8,
    strokeWidth: 2.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 521,
    y: 159,
    width: 21,
    height: 38,
    rx: 8,
    strokeWidth: 2.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 258,
    width: 102,
    height: 160,
    rx: 8,
    stroke: "#8a8b8e",
    strokeWidth: 2,
    strokeDasharray: "7 6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(730,255) scale(0.55)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 152,
    height: 272,
    rx: 18,
    fill: "#ffffff",
    strokeWidth: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 40,
    width: 28,
    height: 126,
    rx: 13,
    strokeWidth: 3.6,
    fill: "#eef2fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,60 H97 M83,88 H97 M83,116 H97 M83,144 H97",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 202,
    r: 15,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 248,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "#191a1c",
    stroke: "none"
  }, "SoKo"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 268,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 2,
    fill: "#191a1c",
    stroke: "none"
  }, "WATER SYSTEMS"))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 342,
    width: 44,
    height: 74,
    rx: 6,
    strokeWidth: 2.4,
    fill: "#ffffff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 352,
    width: 28,
    height: 22,
    rx: 9,
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M881,357 V366 M895,357 V366",
    strokeWidth: 2.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 888,
    cy: 369,
    r: 2.2,
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 382,
    width: 48,
    height: 62,
    rx: 9,
    strokeWidth: 2.4,
    fill: "#ffffff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M874,394 H902 M874,404 H902",
    strokeWidth: 1.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M888,444 C888,468 858,480 834,472 C812,464 806,452 806,438 V412",
    strokeWidth: 6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2b4fdc",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676,152 L562,178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,318 L378,352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,140 L446,164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700,368 L734,300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900,300 L800,320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846,532 L882,452"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "#2b4fdc",
    strokeWidth: 2.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 694,
    cy: 144,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 310,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 132,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 376,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918,
    cy: 292,
    r: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 828,
    cy: 540,
    r: 18
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#2b4fdc",
    stroke: "none",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 21,
    fontWeight: 700,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 694,
    y: 151
  }, "1"), /*#__PURE__*/React.createElement("text", {
    x: 282,
    y: 317
  }, "2"), /*#__PURE__*/React.createElement("text", {
    x: 304,
    y: 139
  }, "3"), /*#__PURE__*/React.createElement("text", {
    x: 682,
    y: 383
  }, "4"), /*#__PURE__*/React.createElement("text", {
    x: 918,
    y: 299
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: 828,
    y: 547
  }, "6"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#6b6c6f",
    stroke: "none",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 20
  }, /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 598
  }, "Catchment tank"), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 598
  }, "Cable runs down the tank, then up to the monitor"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallDiagramCallouts);
export default __webpack_public_path__ + "static/media/install-diagram-callouts.41ac2faf792a555105840eb33e67c19c.svg";
export { ForwardRef as ReactComponent };